import React, { useEffect, useState } from "react";
import { SearchBasicSelectUI } from "../../ui/SearchBasicSelectUI";
import { getVendedores } from "../../../actions/cotizacion";

export const VendedorSelect = ({ name, ...props }) => {
  const [proveedores, SetProveedores] = useState([]);
  const OnLoadVendedores = async () => {
    const datos = await getVendedores();
    SetProveedores(datos);
  };
  useEffect(() => {
    OnLoadVendedores();
  }, []);

  return <SearchBasicSelectUI data={proveedores} {...props} />;
};
